// extracted by mini-css-extract-plugin
export default {"root":"nlhIe95NLABy0b37HOw8","delimiter":"fqpPdvnQPk3Eel2Aa8UQ","link":"ipq_ZXh2HM_naxqH4op7","segment":"JAxVbwc_nhf4BiMMZgFw"};